import { render, staticRenderFns } from "./ArtWorks.vue?vue&type=template&id=5bb3eb2c"
import script from "./ArtWorks.vue?vue&type=script&lang=js"
export * from "./ArtWorks.vue?vue&type=script&lang=js"
import style0 from "./ArtWorks.vue?vue&type=style&index=0&id=5bb3eb2c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports